/* eslint-disable code-style/no-hardcoded-strings */

import { Drawer, styled } from "@mui/material";

const sidebarWidth = 240;

const openedMixinHandler = ({ transitions }) => ({
    overflowX: "hidden",
    transition: transitions.create(
        "width",
        {
            duration: transitions.duration.enteringScreen,
            easing: transitions.easing.sharp,
        },
    ),
    width: `${sidebarWidth}${"px!important"}`,
});

const closedMixinHandler = ({
    breakpoints,
    spacing,
    transitions,
}) => ({
    [breakpoints.up("sm")]: { width: `${"calc("}${spacing(8)} + 1px)` },
    overflowX: "hidden",
    transition: transitions.create(
        "width",
        {
            duration: transitions.duration.leavingScreen,
            easing: transitions.easing.sharp,
        },
    ),
    width: `${"calc("}${spacing(7)} + 1px)`,
});

export const StyledSidebarHeader = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(
        0,
        1,
    ),
    ...theme.mixins.toolbar,
}));

export const StyledSidebar = styled(
    Drawer,
    { shouldForwardProp: (prop) => prop !== "open" },
)(({
    open,
    theme,
}) => ({
    boxSizing: "border-box",
    flexShrink: 0,
    whiteSpace: "nowrap",
    width: sidebarWidth,
    ...open && {
        ...openedMixinHandler(theme),
        "& .MuiDrawer-paper": openedMixinHandler(theme),
    },
    ...!open && {
        ...closedMixinHandler(theme),
        "& .MuiDrawer-paper": closedMixinHandler(theme),
    },
    "& .MuiButtonBase-root.active": { color: theme.palette.primary.main },
}));
